import { render, staticRenderFns } from "./UserLibrarySelector.vue?vue&type=template&id=4315cb42"
import script from "./UserLibrarySelector.vue?vue&type=script&lang=js"
export * from "./UserLibrarySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports